import {
  COOKIE_AUTH_DETAILS,
  COOKIE_CLIENT_AUTH_DETAILS
} from 'globalconfig/constants/keys';
import { deleteCookie, setCookie } from 'globalservices/cookie';
const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  companyName: '',
  rememberMe: false,
  loginData: {},
  webAppConfigurations: null
};

export const login = {
  state: { ...initialState },
  reducers: {
    setLoginSuccess(state, payload) {
      return {
        ...state,
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        companyName: payload.companyName,
        rememberMe: payload.rememberMe,
        enterpriseFeatureDto: payload.enterpriseFeatureDto,
        subscriptions: payload.subscriptions,
        adminSuspended: payload?.adminSuspended,
        previousPaymentFailed: payload?.previousPaymentFailed
      };
    },
    setLoginData(state, payload) {
      return {
        ...state,
        loginData: payload
      }
    },
    setLoginFailed() {
      return { ...initialState };
    },
    setWebAppConfigurations(state, payload) {
      return {
        ...state,
        webAppConfigurations: payload
      };
    }
  },
  effects: (dispatch) => ({
    async fetchLoginConfig(payload) {
      try {
        const getApi = await import(
          `@/config/apis/${window?.$environment?.SERVICE_PROVIDER}`
        );
        const apiObject = getApi.default('webAppConfigurationsApi');
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: apiObject
          },
          callback: payload.callback,
          id: payload.apiId || 'webAppConfigurations'
        });
        if (response) {
          this.setWebAppConfigurations(response);
          if (payload.callback) {
            payload.callback(response);
          }
        }
      } catch (error) {
        console.error('Error fetching login config:', error);
        this.setWebAppConfigurations(null);
        if (payload.callback) {
          payload.callback(null);
        }
      }
    },
    async fetchResellerData(payload) {
      try {
        let response;
        response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: {
              url: `${window.$environment.S3_URL}/reseller_info.json`,
              type: 'get',
              isPublic: true
            }
          },
          callback: payload.callback,
          id: payload.apiId
        });
        if (response) {
          payload.callback(response)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async fetchData(payload) {
      try {
        dispatch.asyncRequests.removeStatus('microsoftloginform');

        let response;
        if (payload.data.token) {
          const getApi = await import(
            `@/config/apis/${window?.$environment?.SERVICE_PROVIDER}`
          );
          const apiObject = getApi.default('authApiWithToken');
          localStorage.removeItem('bannerDate');
          response = await dispatch.asyncRequests.handleAsyncRequests({
            payload: {
              data: { ...payload.data },
              api: apiObject
            },
            callback: payload.callback,
            id: payload.apiId
          });

        } else {
          const getApi = await import(
            `@/config/apis/${window?.$environment?.SERVICE_PROVIDER}`
          );
          const apiObject = getApi.default('authApi');
          localStorage.removeItem('bannerDate');
          this.setLoginData(payload)
          response = await dispatch.asyncRequests.handleAsyncRequests({
            payload: {
              data: { ...payload.data },
              api: apiObject
            },
            id: payload.apiId
          });

        }
        if (response) {
          if (response.status == 206) {
            payload.callback('mfaEnabled')
          } else {
            response.rememberMe = payload?.data?.rememberMe;
            this.setLoginSuccess(response);
            setCookie(COOKIE_AUTH_DETAILS, response, payload?.data?.rememberMe);
            setCookie('dotNumber', response?.dotNumber)
            setCookie('companyId', response?.companyId)
            setCookie('cameraPortalUserId', response?.cameraPortalUserId)
            payload.callback(response);
          }

        }
      } catch (error) {
        this.setLoginFailed();
      }
    },

    async authenticteOtp(payload, root) {
      try {
        this.fetchData({ ...root.login.loginData, data: { ...root.login.loginData.data, mfaOtp: payload.data.mfacode } })

      } catch (error) {
        this.setLoginFailed();
      }
    },

    async fetchMicrosoftLogin(payload) {
      try {
        dispatch.asyncRequests.removeStatus('loginform');

        const getApi = await import(
          `@/config/apis/${window?.$environment?.SERVICE_PROVIDER}`
        );
        const apiObject = getApi.default('microsoftLoginApi');
        localStorage.removeItem('bannerDate');
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            data: { idToken: payload.data.idToken },
            api: apiObject
          },
          callback: payload.callback,
          id: payload.apiId
        });

        if (response) {
          if (response.status == 206) {
            payload.callback('mfaEnabled');
          } else {
            response.rememberMe = payload?.data?.rememberMe || false;
            this.setLoginSuccess(response);
            setCookie(COOKIE_AUTH_DETAILS, response, response.rememberMe);
            setCookie('dotNumber', response?.dotNumber);
            setCookie('companyId', response?.companyId);
            setCookie('cameraPortalUserId', response?.cameraPortalUserId);
            payload.callback(response);
          }
        } else {
          // Handle case when response is null/undefined (user not found, etc.)
          const errorMessage = 'User not found. Please contact your administrator to create an account';
          dispatch.asyncRequests.setStatus({
            api: payload.apiId,
            errorMessage: errorMessage,
            isLoading: false
          });
          if (payload.callback) {
            payload.callback(null, errorMessage);
          }
        }
      } catch (error) {
        let errorMessage = '';

        if (error?.message) {
          if (typeof error.message === 'string') {
            errorMessage = error.message;
          } else if (Array.isArray(error.message)) {
            errorMessage = error.message[0] || 'Microsoft login failed. Please try again.';
          } else if (typeof error.message === 'object') {
            const firstKey = Object.keys(error.message)[0];
            errorMessage = typeof error.message[firstKey] === 'string'
              ? error.message[firstKey].replace(':', '-')
              : 'Microsoft login failed. Please try again.';
          }
        } else if (error?.response?.data?.errors) {
          if (typeof error.response.data.errors === 'string') {
            errorMessage = error.response.data.errors;
          } else if (Array.isArray(error.response.data.errors)) {
            errorMessage = error.response.data.errors[0] || 'Microsoft login failed. Please try again.';
          } else if (typeof error.response.data.errors === 'object') {
            const firstKey = Object.keys(error.response.data.errors)[0];
            errorMessage = typeof error.response.data.errors[firstKey] === 'string'
              ? error.response.data.errors[firstKey]
              : 'Microsoft login failed. Please try again.';
          }
        } else if (error?.response?.data?.errorMessage) {
          errorMessage = error.response.data.errorMessage;
        } else {
          errorMessage = 'Microsoft login failed. Please try again.';
        }

        dispatch.asyncRequests.setStatus({
          api: payload.apiId,
          errorMessage: errorMessage,
          isLoading: false
        });

        this.setLoginFailed();
        if (payload.callback) {
          payload.callback(null, errorMessage);
        }
      }
    },

    async handleLogout(payload) {
      try {
        // const getApi = await import(
        //   `@/config/apis/${window?.$environment?.SERVICE_PROVIDER}`
        // );
        // const apiObject = getApi.default('logoutApi');
        // await dispatch.asyncRequests.handleAsyncRequests({
        //   payload: {
        //     api: apiObject,
        //     callback: payload.callback
        //   },
        //   id: payload.apiId
        // });
        deleteCookie(COOKIE_CLIENT_AUTH_DETAILS);
        deleteCookie(COOKIE_AUTH_DETAILS);
        localStorage.removeItem('bannerDate');
        dispatch({ type: 'RESET_APP' });
        payload.callback('success');
      } catch (error) { }
    }
  })
};
